/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export enum UserType {
  SALES_PERSON = "SALES_PERSON",
  IN_CHARGE = "IN_CHARGE",
  CUSTOMER = "CUSTOMER",
  OWNER = "OWNER",
  UNDEFINED = "UNDEFINED",
  EXTERNAL_CUSTOMER = "EXTERNAL_CUSTOMER",
  EXTERNAL_DESIGNER = "EXTERNAL_DESIGNER",
  EXTERNAL_SALES_PERSON = "EXTERNAL_SALES_PERSON",
  EXTERNAL_OTHER = "EXTERNAL_OTHER",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  SECONDARY_CUSTOMER = "SECONDARY_CUSTOMER",
}
